import { URL_REPLACEMENT } from '$const';
import { get, post } from '~services/api/methods';

export async function postRaiseRequestForm(assetId: string, data: object) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/raise_request/${assetId}`;
  const response = await post(requestUrl, data);
  return response;
}

// Get form fields
export async function fetchRaiseRequestFields(assetId: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/raise_request/${assetId}`;
  const response = await get(requestUrl);
  return response;
}
